module.exports = __webpack_public_path__ + "static/media/carro.8070a430.png";